import { styled } from '@chilipiper/design-system'
import { Tooltip } from '@chilipiper/design-system/src/new'
import { IconLockClosed } from '@chilipiper/icons/figma-generated/src/icon'
import { NavLink as ReactRouterNavLink } from 'react-router-dom'
import { NavLink } from '../../types'
import { NavItem } from './NavItem'

interface Props {
  isActive?: boolean
  isExpanded?: boolean
  link: NavLink
  onClick?: () => void
}

export const LinkNavItem = ({ link, onClick, isExpanded = true }: Props) => {
  if (link.isLocked) {
    return (
      <Tooltip
        content={
          <>
            <Tooltip.Title>{`${link.label} is locked`}</Tooltip.Title>
            <Tooltip.Text>
              Your workspace doesn't have access to {link.label} yet. Contact your admin to upgrade
              your plan.
            </Tooltip.Text>
          </>
        }
        placement='right'
      >
        <Tooltip.CustomFocusableTrigger>
          {({ ...triggerProps }) => (
            <StyledLockedItem aria-disabled='true' {...triggerProps}>
              <NavItem
                isExpanded={isExpanded}
                icon={link.icon}
                label={link.label}
                rightIcon={IconLockClosed}
              />
            </StyledLockedItem>
          )}
        </Tooltip.CustomFocusableTrigger>
      </Tooltip>
    )
  }

  return (
    <Tooltip content={link.label} placement='right' isDisabled={isExpanded}>
      <Tooltip.CustomFocusableTrigger>
        {({ ...triggerProps }) => (
          <StyledNavLink onClick={onClick} to={link.path} {...triggerProps}>
            {({ isActive }) => (
              <NavItem
                isExpanded={isExpanded}
                isActive={isActive}
                icon={link.icon}
                label={link.label}
              />
            )}
          </StyledNavLink>
        )}
      </Tooltip.CustomFocusableTrigger>
    </Tooltip>
  )
}

const StyledNavLink = styled(ReactRouterNavLink)`
  :focus {
    outline: none;
  }
`

const StyledLockedItem = styled.div`
  cursor: default;

  :focus {
    outline: none;
  }
`
